import * as React from 'react';

import { getAppraisal, updateAppraisalType } from '../../../action/admin/Appraisal';
import Appraisal from '../../../component/common/Appraisal';
import Loder from '../../../component/common/Loader'
import { validateForm } from '../../../utils';
import CONSTANT from '../../../constant';

class EditAppraisal extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            code: { value: props.match.params.code },
            appraisalDetail: undefined,
            showLoader: false
        }
    }

    componentDidMount() {
        this.loadList()

    }

    public render() {
        const { appraisalDetail, showLoader } = this.state;
        return (
            <React.Fragment>

                <section>
                    <div className="col-lg-12 main-container">
                        <div className="fluid-container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="col-lg-12 mt-4">
                                        <div className="row">
                                            <div className="col-lg-6 pl-0">
                                                <h5 className="heading-h1">Edit Appraisal Cycle</h5>
                                            </div>
                                        </div>
                                    </div>

                                    {
                                        appraisalDetail &&
                                        <Appraisal
                                            onSubmit={this.onSubmit}
                                            appraisalDetail={appraisalDetail}
                                        />
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {
                    showLoader && <Loder />
                }
            </React.Fragment>

        )
    }

    loadList = () => {
        this.setState({ showLoader: true })
        getAppraisal(this.state.code.value)
            .then((res: any) => {
                if (res) {
                    if (res.result) {
                        this.setState({
                            appraisalDetail: res.result,
                            showLoader: false
                        });
                    }

                }
            })
    }

    onSubmit = (model: any) => {
        //  model.leaveTypeId = this.state.leaveTypeId.value
        this.setState({ showLoader: true })
        updateAppraisalType(model)
            .then((res: any) => {
                alert('Record Update Successfully')
                this.setState({ showLoader: false })
                this.props.history.push(CONSTANT.url.startAppraisal)
            })
            .catch((err: any) => {
                alert(err)
                this.setState({ showLoader: false })
            })
    }
}

export default EditAppraisal;